/*
 * Copyright (c) 2026. Tooling Team
 */

import { createContext } from "react";

/**
 * Provides a stable ref holding the full loinc values array.
 * Using a ref (not the array itself) as the context value means consumers
 * never re-render when the loinc dataset updates — they read .current on demand.
 */
export const LoincValuesContext = createContext(null);
export const LabCodeEvidenceNavigationContext = createContext(null);
